import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ActionButtons from "../../components/action_buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { axiosApi } from "../../../services/axios_api";
import { Dropdown } from "primereact/dropdown";

const EditAddForm = ({
    onHide,
  editable,
  setRes,
  rowData,
  setShowDialog,
  getLogoutsData,
}) => {
    const [loading, setLoading] = useState(false);
    const [kiosks, setKiosks] = useState([]);
    const [features, setFeatures] = useState([]);
    console.log('editable', rowData)
    useEffect(() => {

        const fetchKiosk = async () => {
            setLoading(true);
            try {
                const response = await axiosApi.get(
                    `/Portal/kiosks/get-all`,
                );
                setKiosks(response.data.body);
            } catch (error) {
                toast.error("Failed to fetch Kiosk data.");
            } finally {
                setLoading(false);
            }
        };
        const fetchFeature = async () => {
            setLoading(true);
            try {
                const response = await axiosApi.get(
                    `/Portal/lists/kiosk/features`,
                );
                setFeatures(response.data.body);
            } catch (error) {
                toast.error("Failed to fetch roles data.");
            } finally {
                setLoading(false);
            }
        };
        // fetchMnemonics();
        fetchKiosk();
        fetchFeature()
    }, []);

    const validationSchema = Yup.object({
        durationMinutes: Yup.string().required("Duration Minutes is required."),
        featureId: Yup.string().required("Please select Feature."),
        kioskId: Yup.string().required("Please select Kiosk."),

    });

    // console.log(rowData);
    const formik = useFormik({
        initialValues: {
            durationMinutes: rowData?.durationMinutes || "",
            featureId: rowData?.featureId || "",
            kioskId: rowData?.kioskId || "",
        },
        validationSchema,
        onSubmit: async (data) => {
            setLoading(true);
            try {
                let response;
                if (editable) {
                    data.id = rowData.id;
                    response = await axiosApi.put("/Portal/auto-logout-settings/edit", data);
                    toast.success(" Updated successfully!");
                } else {
                    response = await axiosApi.post("/Portal/auto-logout-settings/add", data);
                    toast.success(" Added successfully!");
                }
                setRes(response.data);
                getLogoutsData();
                setShowDialog(false);
            } catch (error) {
                toast.error(
                    error.response?.data?.message ||
                    "An error occurred. Please try again."
                );
            } finally {
                setLoading(false);
            }
        },
    });



    return (
        <div className="main-form">
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="feeName">
                            Duration Minutes <span className="text-danger"> *</span>
                        </label>
                        <InputText
                            id="durationMinutes"
                            name="durationMinutes"
                            maxLength={"30"}
                            value={formik.values.durationMinutes}
                            placeholder="Enter Duration Minutes"
                            onChange={formik.handleChange}
                        />
                        {formik.touched.durationMinutes && formik.errors.durationMinutes && (
                            <small className="p-error">{formik.errors.durationMinutes}</small>
                        )}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="companyName">
                        Kiosk <span className="text-danger"> *</span>
                        </label>
                        <Dropdown
                            filter
                            id="kioskId"
                            name="kioskId"
                            value={formik.values.kioskId}
                            onChange={formik.handleChange}
                            options={kiosks.map((koisks) => ({
                                label: koisks.name,
                                value: koisks.id,
                            }))}
                            placeholder="Select Role"
                        />
                        {formik.touched.kioskId && formik.errors.kioskId && (
                            <small className="p-error">{formik.errors.kioskId}</small>
                        )}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="companyName">
                        Feature <span className="text-danger"> *</span>
                        </label>
                        <Dropdown
                            filter
                            id="featureId"
                            name="featureId"
                            value={formik.values.featureId}
                            onChange={formik.handleChange}
                            options={features.map((features) => ({
                                label: features.featureName,
                                value: features.featureId,
                            }))}
                            placeholder="Select Feature"
                        />
                        {formik.touched.featureId && formik.errors.featureId && (
                            <small className="p-error">{formik.errors.featureId}</small>
                        )}
                    </div>

                </div>

                <div className="form-buttons mt-4">
                    <ActionButtons
                        loading={loading}
                        onCancel={onHide}
                        onSave={formik.handleSubmit}
                        saveLabel={editable ? "Update Changes" : "Save Changes"}
                        showSave={true}
                        cancelLabel="Cancel"
                    />
                </div>
            </form>
        </div>
    );
};

export default EditAddForm;
